import { render, staticRenderFns } from "./ModalCategory.vue?vue&type=template&id=28c0e6d4&scoped=true&"
import script from "./ModalCategory.vue?vue&type=script&lang=js&"
export * from "./ModalCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalCategory.vue?vue&type=style&index=0&id=28c0e6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0e6d4",
  null
  
)

export default component.exports